export const warningPage = propOverrides => {
  const props = {
    pageId: 'needed_page',
    warning: 'needed',
    actionType: 'next',
    buttonText: 'Acknowledge and continue',
    buttonStyle: 'secondary',
    ...propOverrides
  }

  return {
    id: props.pageId,
    fields: [
      {
        type: 'content',
        content: props.warning
      }
    ],
    action: {
      type: props.actionType,
      buttonText: props.buttonText,
      buttonProps: {
        variation: props.buttonStyle
      }
    }
  }
}
